import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-664b0564")

_pushScopeId("data-v-664b0564")
const _hoisted_1 = { class: "kn-list-item p-d-flex p-flex-row" }
const _hoisted_2 = { class: "kn-list-item-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('workspace.federationDefinition.associationsList')), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_KnFabButton, {
            icon: "fas fa-plus",
            onClick: _ctx.createAssociation
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    content: _withId(() => [
      _createVNode("div", {
        style: _ctx.workspaceFederationDatasetListDescriptor.styles.assContainer
      }, [
        _createVNode(_component_Listbox, {
          id: "associations-list",
          options: _ctx.associations,
          listStyle: _ctx.workspaceFederationDatasetListDescriptor.styles.maxHeight
        }, {
          empty: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          option: _withId((slotProps) => [
            _createVNode("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("span", null, _toDisplayString(slotProps.option.relationship), 1)
              ]),
              _createVNode("i", {
                class: "fas fa-trash-alt delete-association-icon",
                onClick: _withModifiers(($event: any) => (_ctx.deleteAssociationConfirm(slotProps.option)), ["stop"])
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["options", "listStyle"])
      ], 4)
    ]),
    _: 1
  }))
})